import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Link from '@material-ui/core/Link'

const styles = theme => ({
  root: {
    fontSize: 14,
    color: theme.palette.primary.main,
  },
})

const BreadCrumb = ({ classes, links, currentPageLabel }) => {
  return (
    <div className={classes.root}>
      {links.map(link => (
        <Link key={link.label} href={link.to}>
          {link.label}{' '}
        </Link>
      ))}
      > {currentPageLabel}
    </div>
  )
}

BreadCrumb.propTypes = {
  links: PropTypes.array,
  classes: PropTypes.object,
  currentPageLabel: PropTypes.string,
}

export default withStyles(styles)(BreadCrumb)



// WEBPACK FOOTER //
// ./src/components/atoms/BreadCrumb.js